<template>
    <div id="artigo" class="raiz">
      <div class="cabecalho"> 
        <div class="barra">
                <div class="retorno" @click="retornar">
                    <mdi-retornar></mdi-retornar>
                </div>
                <div class="logo">
                    <img src="@/assets/logo.png"/>
                </div>
                <div class="botoes">
                  <div class="carrinho" @click="cesta">
                    <mdi-carrinho></mdi-carrinho>
                  </div>
                </div>
        </div>
        <div class="selecao">{{selecao}}</div>
      </div>
      <div class="artigodesktop" v-if="referencia != null  && !ehMovel" >
        <div class="imagem"   :style="{visibility: !tecladoVisivel ? 'visible' : 'hidden'}">
          <img :src="'' + referencia.imagem + ''"/>
        </div>
        <div class="detalhes">
                <div class="dados">
                  <div class="ordem">{{ referencia.ordem}} - {{referencia.numero}}</div>
                  <div class="descricao">{{ referencia.descricao }}</div>
                  <div class="titcomposicao">COMPOSIÇÃO:</div>
                  <div class="composicao">{{ referencia.composicao }}</div>
                  <div class="titcor">COR:</div>
                  <div class="cor">{{ referencia.corassuf }}</div>
                  <div class="calculo">
                    <div class="titpreco">PREÇO (m):</div>
                    <div class="titmetragem">QUANTIDADE (cm):</div>
                    <div class="titconfirmacao">A PAGAR:</div>
                    <div class="preco">{{ referencia.preco }}</div>
                    <input id="metragem" class="metragem" type="number"  @keyup="metragemMudou" @focus="recebeuFoco('metragem')" v-model="quantidade"/>
                    <div class="confirmacao">R$ {{apagar}}</div>
                  </div>
                  <div class="botoes">
                    <div class="cesta" @click="adicionarCesta">
                      <div class="titcesta">ADICIONAR À CESTA</div>
                      <div class="carrinho">
                          <mdi-carrinho></mdi-carrinho>
                      </div>
                    </div>
                  </div>
                </div>
                    <div class="continuar" @click="retornar">
                    <div class="retornar">
                      <mdi-retornar></mdi-retornar>
                    </div>
                      <div class="titcontinuar">CONTINUAR COMPRANDO</div>
                    </div>
        </div>
      </div>
      <div class="artigomovel" v-if="referencia != null && ehMovel" >
        <div class="imagem">
          <img :src="'' + referencia.imagem + ''"/>
        </div>
        <div class="detalhes">
                <div class="dados">
                  <div class="ordem">{{ referencia.ordem}} - {{referencia.numero}}</div>
                  <div class="descricao">{{ referencia.descricao }}</div>
                  <div class="titcomposicao">COMPOSIÇÃO:</div>
                  <div class="composicao">{{ referencia.composicao }}</div>
                  <div class="titcor">COR:</div>
                  <div class="cor">{{ referencia.corassuf }}</div>
                  <div class="calculo">
                    <div class="titpreco">PREÇO (m):</div>
                    <div class="titmetragem">QUANTIDADE (cm):</div>
                    <div class="titconfirmacao">A PAGAR:</div>
                    <div class="preco">{{ referencia.preco }}</div>
                    <input id="metragem" class="metragem" type="number"  @keyup="metragemMudou" @focus="recebeuFoco('metragem')" v-model="quantidade"/>
                    <div class="confirmacao">R$ {{apagar}}</div>
                  </div>
                  <div class="botoes">
                    <div class="cesta" @click="adicionarCesta">
                      <div class="titcesta">ADICIONAR À CESTA</div>
                      <div class="carrinho">
                          <mdi-carrinho></mdi-carrinho>
                      </div>
                    </div>
                  </div>
                </div>
                    <div class="continuar" @click="retornar">
                    <div class="retornar">
                      <mdi-retornar></mdi-retornar>
                    </div>
                      <div class="titcontinuar">CONTINUAR COMPRANDO</div>
                    </div>
        </div>
      </div>
      <rodape :style="{visibility: !tecladoVisivel ? 'visible' : 'hidden'}"></rodape>
    </div>

</template>
<style lang="scss" scoped>
  @import "@/assets/scss/artigo.scss";
</style>
<script>
import mvitrine from '@/dados/mvitrine'
// import g from '@/softam/geral'

//import Barra from '../components/barra.vue'
import Rodape from '../components/rodape.vue'

export default {
  components:{
  //  'barra': Barra,
    'rodape': Rodape,
  
  },
  data: function(){

    return {

      ehMovel: true,

      referencia: null,
      temCarrinho: false,
      quantidade: 99.99,
      preco: 1,
      apagar: 0,

      tecladoVisivel: false,
      alturaTela: 500,

      largImagem: '80%',

      selecao: ""

    }

  },
  methods:{

    alturaMudou: function(){

    },

            recebeuFoco: function(id){

             const element = document.getElementById(id);
             if (element){
               console.log(element);
             }

        }, 


    metragemMudou: function(){
        //  this.apagar = g.formatarF(this.quantidade/100.0 * this.preco,2); 
    },

    recuperarReferencia(){
      mvitrine.recuperarReferencia(this.idReferencia).then(()=>{
        this.referencia=mvitrine.retorno;

      })
    },
    retornar(){
      console.log('retornar');
      this.$router.go(-1);

    },
    cesta(){
      this.$router.go(-1);
    },
    adicionarCesta(){
      var valor = parseFloat(this.apagar.replace(".","").replace(",","."));
      if (valor < 1){
        return;
      }
      var cesta = this.$store.getters.cestaRecuperar;
      if (cesta == undefined){
        cesta = [];
      }

      var adicionar = true;
      if (cesta.length>0){
        for (var i=0;i<cesta.length;i++){
          var cs = cesta[i];
          if (cs.codreferencia == this.referencia.id){
            adicionar = false;
            break;
          }
        }
      }
      if (adicionar){
          var c = {
            datacompra: new Date(),
            codreferencia: this.referencia.id,
            descricao: this.referencia.descricao,
            cor: this.referencia.corassuf, 
            imagem: this.referencia.imagem,
            quantidade: this.quantidade,
            preco: this.preco,
            valor: valor,
            pedido: ''
          }
          cesta.push(c);
          this.$store.commit('cestaMudou',cesta);
          this.$router.push("cesta");
      }

    }
  },
  created(){

    this.ehMovel = window.outerWidth <500;

    this.temCarrinho = false;
    if (localStorage.getItem("carrinho") != null && localStorage.getItem("carrinho").toString().length > 0){
      this.temCarrinho = true;
    }
    let idreferencia = sessionStorage.getItem("vitrine.idreferencia");
    mvitrine.recuperarReferencia(idreferencia).then(()=>{
      this.referencia = mvitrine.retorno;
      this.selecao = this.referencia.ordem + " - " + this.referencia.numero;
      this.preco = parseFloat(this.referencia.preco.replace("R$","").replace(",","."));
      this.quantidade=100;
    });
  },
  mounted(){


        let viewheight = window.outerHeight;
        let viewwidth = window.outerWidth;
        let viewport = document.querySelector("meta[name=viewport]");
        viewport.setAttribute("content", "height=" + viewheight + "px, width=" + viewwidth + "px, initial-scale=1.0");

    // this.alturaTela= window.innerHeight;
    // window.addEventListener('resize', this.alturaMudou);

    this.$store.commit('mostrarPesquisaMudou',false);
  },
//   beforeDestroy() {
//     window.removeEventListener('resize', this.alturaMudou)
// }

}
</script>